import { useTranslation } from "react-i18next";

import { REFERENCE_SINK_RATE_MS } from "../api";
import { ExternalReference } from "../trust/ExternalReference";
import { TRUST_LINKS } from "../trust/content";

export function AboutPage() {
  const { t } = useTranslation();
  const sections = [
    ["lineageTitle", "lineageBody"], ["developmentTitle", "developmentBody"],
    ["addsTitle", "addsBody"], ["contractTitle", "contractBody"],
    ["honestTitle", "honestBody"], ["feedbackTitle", "feedbackBody"]
  ] as const;
  return (
    <div className="page about-page">
      <header className="about-masthead"><div><span className="about-label">{t("nav.about")}</span><h1>{t("about.title")}</h1></div><p>{t("about.intro")}</p></header>
      <div className="about-grid">
        {sections.map(([title, body], index) => (
          <section className="about-card" key={title}>
            {title === "developmentTitle" ? <span className="eyebrow">{t("about.developmentLabel")}</span> : null}
            <h2>{t(`about.${title}`)}</h2>
            <p>{t(`about.${body}`, { sink: REFERENCE_SINK_RATE_MS.toFixed(2) })}</p>
            {title === "developmentTitle" ? <p>{t("about.developmentFuture")}</p> : null}
            {index === 0 ? <div className="about-primary-links">
              <ExternalReference href={TRUST_LINKS.tjCurrentWindgrams}>WXtoFly</ExternalReference>
              <ExternalReference href={TRUST_LINKS.tjOriginalSite}>WXtoFly</ExternalReference>
              <ExternalReference href={TRUST_LINKS.tjWindgramReading}>Windgram Reading</ExternalReference>
            </div> : null}
            {index === sections.length - 1 ? <div className="about-primary-links"><ExternalReference href={TRUST_LINKS.githubIssues}>{t("about.issueTracker")}</ExternalReference></div> : null}
          </section>
        ))}
      </div>
    </div>
  );
}
